import axiosInstanceNode from "@/api/axiosInstanceNode";

export const addLeadsToCampaign = async (campaignId, contacts) => {
  try {
    const response = await axiosInstanceNode.post(`/enrollment/create`, {
      campaignId,
      contacts,
    });
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      "Failed to add contacts to campaign. Please try again.";
    throw new Error(errorMessage);
  }
};

export const preflightEnrollment = async ({ campaignId, contactIds }) => {
  try {
    const response = await axiosInstanceNode.post("/enrollment/preflight", {
      campaignId,
      contactIds,
    });
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      "Failed to validate contact email addresses. Please try again.";
    throw new Error(errorMessage);
  }
};

export const moveContactsBatch = async ({ mode, campaignId, contacts }) => {
  try {
    const payload = { mode, contacts };
    if (campaignId != null && campaignId !== "") {
      payload.campaignId = campaignId;
    }
    const response = await axiosInstanceNode.post(`/enrollment/batch`, payload);
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      "Failed to move contacts. Please try again.";
    throw new Error(errorMessage);
  }
};

export const startEnrollmentBatch = async (campaignId, contacts) =>
  moveContactsBatch({ mode: "campaign", campaignId, contacts });

export const getEnrollmentBatch = async (batchJobId) => {
  try {
    const response = await axiosInstanceNode.get(`/enrollment/batch/${batchJobId}`);
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      "Failed to get enrollment batch status.";
    throw new Error(errorMessage);
  }
};

export const subscribeEnrollmentBatchEvents = (batchJobId, { onEvent, onError } = {}) => {
  const baseURL = axiosInstanceNode.defaults.baseURL || "";
  const token = localStorage.getItem("token");
  const params = token ? `?access_token=${encodeURIComponent(token)}` : "";
  const source = new EventSource(
    `${baseURL}/enrollment/batch/${batchJobId}/events${params}`
  );

  const eventNames = [
    "batch.snapshot",
    "batch.created",
    "batch.validated",
    "enrollments.created",
    "content.step",
    "profile.step",
    "research.step",
    "account.step",
    "batch.progress",
    "batch.completed",
  ];
  for (const eventName of eventNames) {
    source.addEventListener(eventName, (event) => {
      onEvent?.({
        type: eventName,
        data: JSON.parse(event.data || "{}"),
      });
    });
  }
  source.onerror = (event) => {
    onError?.(event);
  };
  return () => source.close();
};

export const getCampaignLeads = async (
  campaignId,
  page = 1,
  limit = 10,
  searchQuery = "",
) => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    if (searchQuery) params.append("search", searchQuery);

    const response = await axiosInstanceNode.get(
      `/enrollment/list/${campaignId}?${params.toString()}`,
    );
    const leadsArray = response.data?.data || response.data || [];
    const totalCount = response.data?.total || leadsArray.length;
    return { leads: leadsArray, total: totalCount, page, limit };
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      "Failed to get campaign leads. Please try again.";
    throw new Error(errorMessage);
  }
};

export const deleteLead = async (ids) => {
  try {
    const idArray = Array.isArray(ids) ? ids : [ids];
    const response = await axiosInstanceNode.post(`/enrollment/delete`, {
      ids: idArray,
    });
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      "Failed to delete lead. Please try again.";
    throw new Error(errorMessage);
  }
};
